/**
 * CopyTenantId — copyable Tenant ID panel shown on the License Not Found
 * screen so a user can share it with their admin to get a license provisioned.
 */

import { useState } from 'react';

export function CopyTenantId({ tenantId }: { tenantId: string }) {
    const [copied, setCopied] = useState(false);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(tenantId);
        } catch {
            const el = document.createElement('textarea');
            el.value = tenantId;
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
        }
        setCopied(true);
        setTimeout(() => setCopied(false), 2500);
    };

    return (
        <div style={{
            marginTop: 20,
            padding: '16px',
            background: 'linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)',
            border: '1px solid #bae6fd',
            borderRadius: 12,
            textAlign: 'left',
        }}>
            <p style={{ margin: '0 0 4px', fontSize: 11, fontWeight: 700, color: '#0369a1', textTransform: 'uppercase', letterSpacing: '0.08em' }}>
                🔑 Your Tenant ID
            </p>
            <p style={{ margin: '0 0 10px', fontSize: 12, color: '#0c4a6e', lineHeight: 1.5 }}>
                Share this with your administrator or Injio support to activate a license for your organisation.
            </p>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <code style={{
                    flex: 1,
                    padding: '9px 12px',
                    background: '#ffffff',
                    border: '1px solid #bae6fd',
                    borderRadius: 8,
                    fontSize: 12,
                    fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
                    color: '#0f172a',
                    wordBreak: 'break-all',
                    lineHeight: 1.4,
                }}>
                    {tenantId}
                </code>
                <button
                    onClick={handleCopy}
                    title={copied ? 'Copied!' : 'Copy Tenant ID'}
                    style={{
                        flexShrink: 0,
                        padding: '9px 14px',
                        borderRadius: 8,
                        border: 'none',
                        cursor: 'pointer',
                        fontWeight: 600,
                        fontSize: 13,
                        transition: 'background 0.2s',
                        background: copied ? '#16a34a' : '#0284c7',
                        color: '#ffffff',
                        minWidth: 80,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 4,
                    }}
                >
                    {copied ? '✓ Copied' : '📋 Copy'}
                </button>
            </div>
        </div>
    );
}
